import React, { useEffect, useState } from "react";
import "./style.css";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
  PieChart,
  ResponsiveContainer,
  Pie,
} from "recharts";
import { getData } from "../../../api/method";
import moment from "moment/moment";

function Dashboard() {
  const [dataOrder, setDataOrder] = useState([]);
  const [dataProduct, setDataProduct] = useState([]);

  const getDataProduct = async () => {
    try {
      const result = await getData("/api/Product");
      setDataProduct(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  const getDataOrder = async () => {
    try {
      const result = await getData("/api/Order");
      setDataOrder(result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDataProduct();
    getDataOrder();
  }, []);

  const totalAmount = dataOrder.reduce(
    (i, item) => (i += 0 + item.totalPrice),
    0
  );

  const grossProduct = dataOrder.reduce(
    (i, item) => (i += 0 + item.orderDetails.length),
    0
  );

  const waitting = dataOrder.filter((item) => item.status === 0);
  const delivered = dataOrder.filter((item) => item.status === 1);
  const shipping = dataOrder.filter((item) => item.status === 2);
  const canceled = dataOrder.filter((item) => item.status === 3);

  const orderStatus = [
    {
      name: "waitting",
      value: waitting.length,
    },
    {
      name: "delivered",
      value: delivered.length,
    },
    {
      name: "shipping",
      value: shipping.length,
    },
    {
      name: "canceled",
      value: canceled.length,
    },
  ];

  const renderLabel = function (orderStatus) {
    return orderStatus.name + " : " + orderStatus.value;
  };

  return (
    <div className="w-100 pt-4 px-5 py-5">
      <div className="d-flex justify-content-center align-items-center pt-5">
        <div className="total_count">
          <p className="fs-24">Total order</p>{" "}
          <p className="fs-5 t-red mt-2">{dataOrder.length}</p>
        </div>

        <div className="total_count">
          <p className="fs-24">Total amount</p>
          <p className="fs-5 t-red mt-2">
            {totalAmount.toLocaleString("vi")} &#273;
          </p>
        </div>

        <div className="total_count">
          <p className="fs-24">Gross product</p>
          <p className="fs-5 t-red mt-2">{grossProduct}</p>
        </div>
      </div>

      <div className="d-flex mt-5 align-items-center justify-content-center w-100">
        {dataOrder.length > 0 ? (
          <>
            <div className="pt-5 d-flex justify-content-center">
              <LineChart
                width={1000}
                height={500}
                data={dataOrder}
                margin={{
                  top: 20,
                  right: 30,
                  left: 20,
                  bottom: 10,
                }}
              >
                <CartesianGrid strokeDasharray="5 5" />
                <XAxis
                  dataKey="date"
                  height={60}
                  tick={<CustomizedAxisTick />}
                />
                <YAxis fontSize={16} />
                <Tooltip content={<CustomTooltip />} />
                <Legend />
                <Line
                  type="monotone"
                  dataKey="totalPrice"
                  stroke="#4aa96c"
                  activeDot={{ r: 5 }}
                >
                  <LabelList content={<CustomizedLabel />} />
                </Line>
              </LineChart>
            </div>

            <div style={{ width: 500, height: 300 }}>
              <ResponsiveContainer>
                <PieChart>
                  <Pie
                    dataKey="value"
                    data={orderStatus}
                    fill="#4aa96c"
                    label={renderLabel}
                    fontSize={16}
                  />
                </PieChart>
              </ResponsiveContainer>
            </div>
          </>
        ) : (
          <>No Chart</>
        )}
      </div>
    </div>
  );
}

export default Dashboard;

const CustomTooltip = (props) => {
  const { active, payload, label } = props;
  if (active && payload && payload.length) {
    return (
      <div className="border border-success p-2 rounded">
        <p className="fs-15">{moment(label).format("L")}</p>
        <p className="fs-15">
          Total Price:{" "}
          <span className="t-red">{`${payload[0].value.toLocaleString(
            "vi"
          )}`}</span>{" "}
        </p>
      </div>
    );
  }

  return null;
};

const CustomizedLabel = (props) => {
  const { x, y, stroke, value } = props;

  return (
    <text x={x} y={y} dy={-4} fill={stroke} fontSize={10} textAnchor="middle">
      {value}
    </text>
  );
};

const CustomizedAxisTick = (props) => {
  const { x, y, payload } = props;

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="start"
        fill="#666"
        transform="rotate(0)"
        fontSize={16}
      >
        {moment(payload.value).format("L")}
      </text>
    </g>
  );
};
